export const LECTURER_REQUESTS_LOADING = 'LECTURER_REQUESTS_LOADING';
export const LECTURER_REQUESTS_LOADED = 'LECTURER_REQUESTS_LOADED';
export const LECTURER_REQUESTS_ERROR = 'LECTURER_REQUESTS_ERROR';

export const LECTURER_REQUEST_LOADING = 'LECTURER_REQUEST_LOADING';
export const LECTURER_REQUEST_LOADED = 'LECTURER_REQUEST_LOADED';
export const LECTURER_REQUEST_ERROR = 'LECTURER_REQUEST_ERROR';

export const LECTURER_REQUEST_APPROVE_OR_DECLINE_LOADING =
  'LECTURER_REQUEST_APPROVE_OR_DECLINE_LOADING';
export const LECTURER_REQUEST_APPROVE_OR_DECLINE_SUCCESS =
  'LECTURER_REQUEST_APPROVE_OR_DECLINE_SUCCESS';
export const LECTURER_REQUEST_APPROVE_OR_DECLINE_FAIL =
  'LECTURER_REQUEST_APPROVE_OR_DECLINE_FAIL';

export const LECTURER_REQUEST_APPROVE_OR_DECLINE_RESET =
  'LECTURER_REQUEST_APPROVE_OR_DECLINE_RESET';
